module.exports = __webpack_public_path__ + "media/components/src/assets/images/news/news_13-947e6e91ceb1d7a7961b7afae8220594.jpg";